import React from 'react';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <ModuleRoute key="axp-page-wrapper" moduleName="axp-page-wrapper">
    <ModuleRoute
      key="app-status-base"
      path="/"
      moduleName="unify-status-site"
    />
  </ModuleRoute>,
  <ModuleRoute key="axp-page-wrapper" moduleName="axp-page-wrapper">
    <ModuleRoute
      key="app-status"
      path="app-status"
      moduleName="unify-status-site"
    />
  </ModuleRoute>,
  <ModuleRoute key="axp-page-wrapper" moduleName="axp-page-wrapper">
    <ModuleRoute
      key="app-status-reroute"
      path="eaol/welcome.do"
      moduleName="unify-status-site"
    />
  </ModuleRoute>,
  <ModuleRoute key="axp-page-wrapper" moduleName="axp-page-wrapper">
    <ModuleRoute key="catch-all" path="*" moduleName="unify-status-site" />
  </ModuleRoute>
];

export default childRoutes;
